import { render } from "./optional-filter-tags.vue?vue&type=template&id=77d13e6a&ts=true"
import script from "./optional-filter-tags.ts?vue&type=script&lang=ts&external"
export * from "./optional-filter-tags.ts?vue&type=script&lang=ts&external"

import "./optional-filter-tags.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__